const dict = {
  chooseLang: `Επιλέξτε γλώσσα`,

  // Άδεια
  instructions: `Οδηγίες`,
  step1: `Βήμα 1: Σαρώστε τον κωδικό QR`,
  locateqr: `Βρείτε τον κωδικό QR στα δεξιά σας.`,
  useSmartphone: `Χρησιμοποιήστε την κάμερα του smartphone σας ή μια εφαρμογή σαρωτή QR για να τον σαρώσετε. Αυτό θα σας μεταφέρει στο επόμενο βήμα.`,
  step2: `Βήμα 2: Εισαγάγετε τις πληροφορίες της λίστας αναπαραγωγής`,
  afterScan: `Αφού σαρώσετε τον κωδικό QR, θα σας ζητηθεί να εισαγάγετε τις πληροφορίες της λίστας αναπαραγωγής σας.`,
  makeSure: `Βεβαιωθείτε ότι έχετε συμπληρώσει όλα τα απαιτούμενα πεδία.`,
  step3: `Βήμα 3: Επιστροφή στην εφαρμογή`,
  onceYou: `Μόλις εισαγάγετε τις λεπτομέρειες της λίστας αναπαραγωγής, μπορείτε να επιστρέψετε στην εφαρμογή και να συνεχίσετε την εμπειρία σας.`,
  refresh: `ΑΝΑΝΕΩΣΗ`,
  playlist: `Λίστα αναπαραγωγής`,
  bigPlaylist: `ΛΙΣΤΕΣ ΑΝΑΠΑΡΑΓΩΓΗΣ`,
  noLicence: `Δεν έχετε άδεια.`,
  scanLicence: `Σαρώστε για να αγοράσετε άδεια.`,
  noPlaylist: `Δεν έχετε καμία λίστα αναπαραγωγής`,
  privacyBig: `ΛΕΙΤΟΥΡΓΙΑ ΙΔΙΩΤΙΚΟΤΗΤΑΣ`,
  scanToAddBig: `ΣΑΡΩΣΤΕ ΓΙΑ ΠΡΟΣΘΗΚΗ ΛΙΣΤΑΣ`,
  scanToBuyBig: `ΣΑΡΩΣΤΕ ΓΙΑ ΑΓΟΡΑ ΑΔΕΙΑΣ`,
  orVisit: `ή επισκεφθείτε`,
  andenterdeviceID: `και εισαγάγετε αυτό το αναγνωριστικό συσκευής:`,
  removePlaylist: `Αφαίρεση λίστας αναπαραγωγής`,
  wantToRemove: `Θέλετε να την αφαιρέσετε;`,
  cancelBig: `ΑΚΥΡΩΣΗ`,

  // Αρχική σελίδα
  bigLiveTv: `ΖΩΝΤΑΝΗ ΤΗΛΕΟΡΑΣΗ`,
  bigMovies: `ΤΑΙΝΙΕΣ`,
  bigSeries: `ΣΕΙΡΕΣ`,

  // Μενού καναλιών
  noChannels: `Αυτή η λίστα αναπαραγωγής δεν περιέχει δεδομένα καναλιών`,
  searchChannels: `Αναζήτηση καναλιού`,
  tapToPlay: `Πατήστε για αναπαραγωγή του βίντεο.`,
  categoryEmpty: `Αυτή η κατηγορία είναι κενή`,

  // Ταινίες
  noMovies: `Αυτή η λίστα αναπαραγωγής δεν περιέχει δεδομένα ταινιών`,
  searchMovies: `Αναζήτηση ταινιών`,

  // Σειρές
  noSeries: `Αυτή η λίστα αναπαραγωγής δεν περιέχει δεδομένα σειρών`,
  searchSeries: `Αναζήτηση σειρών`,

  // Οντότητα
  play: `ΑΝΑΠΑΡΑΓΩΓΗ`,
  recommendations: `Προτάσεις`,

  // Πληροφορίες χρήστη
  userInfo: `Πληροφορίες χρήστη`,
  aboutApp: `Σχετικά με την εφαρμογή`,

  // Πληροφορίες λογαριασμού
  account: `Λογαριασμός`,
  subscriptions: `Συνδρομές`,
  privacyPilicy: `Απόρρητο και Πολιτική`,
  languge: `Γλώσσα`,
  english: `Αγγλικά`,
  italian: `Ιταλικά`,
  german: `Γερμανικά`,
  spanish: `Ισπανικά`,
  french: `Γαλλικά`,
  greek: `Ελληνικά`,

  // Τελευταίες πληροφορίες
  playInfo: `Πληροφορίες λίστας αναπαραγωγής`,
  playName: `Όνομα λίστας αναπαραγωγής:`,
  host: `Διακομιστής:`,
  username: `Όνομα χρήστη:`,
  password: `Κωδικός πρόσβασης:`,
  packName: `Όνομα πακέτου:`,
  expireDate: `Ημερομηνία λήξης:`,

  // Πολιτική απορρήτου
  one: `1. Αποποίηση ευθυνών περιεχομένου: Το Applay είναι μια πλατφόρμα που έχει σχεδιαστεί για να βελτιώσει την ψηφιακή σας εμπειρία. Ωστόσο, είναι σημαντικό να σημειωθεί ότι το Applay δεν φιλοξενεί, παρέχει ή διανέμει περιεχόμενο βίντεο. Η υπηρεσία μας έχει σχεδιαστεί για να υποστηρίζει το ψηφιακό σας ταξίδι, αλλά δεν φέρουμε ευθύνη για τη διαθεσιμότητα, την ποιότητα ή το περιεχόμενο του υλικού βίντεο, καθώς αυτό βρίσκεται εκτός του πεδίου εφαρμογής των υπηρεσιών μας.`,
  two: `2. Καμία ευθύνη για περιεχόμενο τρίτων: Η Applay LLC δεν φέρει ευθύνη για οποιοδήποτε περιεχόμενο τρίτων που μπορεί να έχετε πρόσβαση μέσω της εφαρμογής μας. Η αλληλεπίδρασή σας με οποιοδήποτε εξωτερικό περιεχόμενο, συμπεριλαμβανομένης της νομιμότητας, της αξιοπιστίας ή της καταλληλότητάς του, γίνεται αποκλειστικά με δική σας ευθύνη.`,
  three: `3. Δικαιοδοσία και συμμόρφωση: Η Applay LLC λειτουργεί υπό τη δικαιοδοσία των Ηνωμένων Πολιτειών. Οι χρήστες είναι υπεύθυνοι για τη διασφάλιση ότι η χρήση της εφαρμογής συμμορφώνεται με όλους τους τοπικούς, πολιτειακούς και ομοσπονδιακούς νόμους.`,
  four: `4. Πολιτική τιμών: Οι τιμές για τις υπηρεσίες του Applay υπόκεινται σε αλλαγές ανά πάσα στιγμή χωρίς προηγούμενη ειδοποίηση. Αποδεχόμενοι αυτή τη συμφωνία, αναγνωρίζετε και συμφωνείτε ότι οι τιμές ενδέχεται να διαφέρουν και ότι οποιεσδήποτε αλλαγές δεν θα επηρεάσουν την τρέχουσα υπηρεσία σας μέχρι την ανανέωση της συνδρομής σας.`,
  five: `5. Χωρίς εγγύηση: Η εφαρμογή Applay και οι υπηρεσίες της παρέχονται "ως έχουν", χωρίς καμία ρητή ή σιωπηρή εγγύηση, συμπεριλαμβανομένων, ενδεικτικά, των σιωπηρών εγγυήσεων εμπορευσιμότητας, καταλληλότητας για συγκεκριμένο σκοπό και μη παραβίασης.`,
  six: `6. Αποδοχή των όρων: Πατώντας Συμφωνώ, συμφωνείτε να δεσμεύεστε από τους όρους αυτής της αποποίησης ευθύνης και αναγνωρίζετε ότι οποιαδήποτε παραβίαση μπορεί να οδηγήσει σε τερματισμό της πρόσβασής σας στις υπηρεσίες Applay.`,
  orbixUserAgreement: `ΣΥΜΦΩΝΙΑ ΧΡΗΣΤΗ ΚΑΙ ΑΠΟΠΟΙΗΣΗ ΕΥΘΥΝΗΣ Applay`,
  beforeyouProcc: `Πριν συνεχίσετε, διαβάστε και αποδεχτείτε τους ακόλουθους όρους και προϋποθέσεις:`,

  // Πολιτική απορρήτου Evomedia
  evomediaTitle: `Πολιτική Απορρήτου Evo TV`,
  evomediaSubtitle: `Παρακαλούμε διαβάστε τις παρακάτω πληροφορίες σχετικά με τον τρόπο επεξεργασίας των δεδομένων σας:`,
  evomediaSection1Title: `1. Επεξεργασία και Συλλογή Τεχνικών Δεδομένων`,
  evomediaSection1Body1: `Η εφαρμογή evo tv έχει σχεδιαστεί αποκλειστικά ως τεχνικό εργαλείο για τους επιλέξιμους πελάτες της Evomedia. Η εφαρμογή δεν διαθέτει φόρμες μη αυτόματης εγγραφής, δημιουργία λογαριασμού εντός της εφαρμογής, ούτε συλλέγει άμεσα προσωπικά στοιχεία (όπως το όνομά σας, τον αριθμό τηλεφώνου ή τη διεύθυνση email).`,
  evomediaSection1Body2: `Ωστόσο, για να καταστεί δυνατή η ροή πολυμέσων και να διασφαλιστεί η ασφάλεια της υπηρεσίας, το σύστημα επεξεργάζεται την ακόλουθη κατηγορία δεδομένων:`,
  evomediaSection1Body3: `Αναγνωριστικά Συσκευής: Η διεύθυνση MAC της συσκευής ή ένα εσωτερικό αναγνωριστικό πελάτη μεταδίδεται με ασφάλεια (μέσω SSL/HTTPS) στους διακομιστές μας με αποκλειστικό σκοπό την επικύρωση, την πιστοποίηση και την εξουσιοδότηση πρόσβασης στις ροές πολυμέσων που συνδέονται με το πρόγραμμά σας.`,
  evomediaSection1Body4: `Νομική Βάση και Σκοπός: Η επεξεργασία αυτών των αναγνωριστικών είναι απολύτως απαραίτητη για την εκτέλεση μιας σύμβασης (παροχή της ζητούμενης υπηρεσίας streaming) και για την ασφάλεια και την πρόληψη απάτης (διασφαλίζοντας ότι μόνο εξουσιοδοτημένες συσκευές έχουν πρόσβαση στις προστατευμένες ροές). Αυτά τα τεχνικά δεδομένα δεν χρησιμοποιούνται ποτέ για σκοπούς μάρκετινγκ, δεν κοινοποιούνται ποτέ σε τρίτους και δεν χρησιμοποιούνται για την παρακολούθηση του ευρύτερου ιστορικού περιήγησής σας.`,
  evomediaSection2Title: `2. Δικαιώματα Χρήστη (GDPR)`,
  evomediaSection2Body1: `Σύμφωνα με τον Γενικό Κανονισμό για την Προστασία Δεδομένων (GDPR), δεδομένου ότι τα τεχνικά αναγνωριστικά συνδέονται με τον υποκείμενο λογαριασμό πελάτη σας, διατηρείτε το δικαίωμα πρόσβασης, διόρθωσης, περιορισμού ή αίτησης διαγραφής των δεδομένων που σχετίζονται με τη συσκευή σας. Για να ασκήσετε αυτά τα δικαιώματα, επικοινωνήστε μαζί μας στο suporte@evomedia.pt.`,
  evomediaSection3Title: `3. Απόρρητο Ανηλίκων`,
  evomediaSection3Body1: `Δεν προωθούμε άμεσα τις υπηρεσίες μας σε παιδιά, ούτε συλλέγουμε εν γνώσει μας δεδομένα από ανηλίκους κάτω των 13 ετών. Η πρόσβαση στην εφαρμογή διαχειρίζεται και εξουσιοδοτείται από τον κάτοχο του λογαριασμού (τον ενήλικο πελάτη).`,
  evomediaSection4Title: `4. Αλλαγές σε αυτή την Πολιτική`,
  evomediaSection4Body1: `Ενδέχεται να ενημερώνουμε την Πολιτική Απορρήτου μας από καιρό σε καιρό, ώστε να αντικατοπτρίζει τεχνικές αναβαθμίσεις ή κανονιστικές αλλαγές. Οποιαδήποτε ενημέρωση θα τίθεται σε ισχύ άμεσα μόλις δημοσιεύεται σε αυτή τη σελίδα.`,
  evomediaSection5Title: `5. Επικοινωνία`,
  evomediaSection5Body1: `Εάν έχετε οποιεσδήποτε ερωτήσεις σχετικά με το απόρρητό σας ή τη τεχνική διαχείριση της εφαρμογής, επικοινωνήστε μαζί μας μέσω:`,
  evomediaSection5Body2: `Επίσημο Email Υποστήριξης: suporte@evomedia.pt`,
  evomediaSection5Body3: `Email Λογαριασμού Προγραμματιστή: evomediamobile@gmail.com`,

  //additional
  exitApp: "Έξοδος από το Applay",
  wantToExit: "Είστε σίγουροι ότι θέλετε να εξέλθετε από το Applay;",
  Resume: "Συνέχιση",

  whatsnewinv: "Τι νέο υπάρχει στην v",
  whatsnew: "Τι νέο υπάρχει",
  instanthomescreen: "Βελτιωμένη Πλοήγηση Μενού Καναλιών",
  instanthomescreendesc:
    "Βελτιωμένη ροή πλοήγησης και εμπειρία χρήστη στην επιλογή καναλιών.",
  turbomoviesearch: "Ολοκληρωμένες Πληροφορίες Ρυθμίσεων",
  turbomoviesearchdesc:
    "Πιο λεπτομερείς ρυθμίσεις και επιλογές διαμόρφωσης συγκεντρωμένες σε ένα μέρος.",
  lighterondataandbattery: "Έξυπνη Λειτουργία Συνέχισης",
  lighterondataandbatterydesc:
    "Αποθηκεύει και επαναφέρει αυτόματα τη θέση αναπαραγωγής σας απρόσκοπτα.",
  underthehoodfixes: "Εσωτερικές Διορθώσεις",
  underthehoodfixesdesc:
    "Βελτιωμένη σταθερότητα του αναπαραγωγέα και αξιοπιστία των λειτουργιών αναζήτησης.",
};

export default dict;
